// src/components/Services/PDF/ServiceOrderServiceDocumentButton.tsx
import React, { useState } from 'react';
import { pdf } from '@react-pdf/renderer';
import * as Sentry from '@sentry/react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { FileText, Loader2 } from 'lucide-react';
import {
  ServiceOrderServiceDocument,
  ServiceOrderServiceDocumentProps,
} from './ServiceOrderServiceDocument';

interface ServiceOrderServiceDocumentButtonProps
  extends ServiceOrderServiceDocumentProps {
  serviceOrderId: string;
}

export function ServiceOrderServiceDocumentButton({
  serviceOrderId,
  serviceOrder,
  customer,
  equipment,
  company,
}: ServiceOrderServiceDocumentButtonProps) {
  const [isGenerating, setIsGenerating] = useState(false);

  const handleClick = () => {
    // window.open DEVE ser síncrono aqui — dentro do user gesture
    const printWindow = window.open('', '_blank');
    if (!printWindow) {
      toast.error(
        'Bloqueador de pop-ups ativo. Permita pop-ups para este site.',
      );
      return;
    }

    setIsGenerating(true);
    pdf(
      <ServiceOrderServiceDocument
        serviceOrder={serviceOrder}
        customer={customer}
        equipment={equipment}
        company={company}
      />,
    )
      .toBlob()
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        printWindow.location.href = url;
        setTimeout(() => URL.revokeObjectURL(url), 60_000);
      })
      .catch((error: unknown) => {
        printWindow.close();
        toast.error('Erro ao gerar o documento. Tente novamente.');
        Sentry.captureException(error, {
          extra: { service_order_id: serviceOrderId },
        });
      })
      .finally(() => setIsGenerating(false));
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleClick}
      disabled={isGenerating}
    >
      {isGenerating ? (
        <>
          <Loader2 className="h-4 w-4 mr-2 animate-spin" />
          Gerando...
        </>
      ) : (
        <>
          <FileText className="h-4 w-4 mr-2" />
          Documento de Serviço
        </>
      )}
    </Button>
  );
}
